import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

interface DeleteInterviewerModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  interviewerName: string
}

export const DeleteInterviewerModal = ({
  isOpen,
  onClose,
  onConfirm,
  interviewerName,
}: DeleteInterviewerModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Confirm removal</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        Are you sure you want to remove <b>{interviewerName}</b> from this
        interview?
      </ModalBody>
      <ModalFooter>
        <Button
          rounded={'1.25rem'}
          colorScheme={'red'}
          onClick={onConfirm}
          mr={3}
        >
          Remove
        </Button>
        <Button
          onClick={onClose}
          rounded={'1.25rem'}
          variant="brand-solid-white"
        >
          Cancel
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)
